import { Component,Inject, OnDestroy, OnInit } from '@angular/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';
import { RmaService } from '../../../../rma/rma-services/rma.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-waygate-rma-product-details-modal',
  standalone: false,
  templateUrl: './waygate-rma-product-details-modal.component.html',
  styleUrl: './waygate-rma-product-details-modal.component.scss'
})
export class WaygateRmaProductDetailsModalComponent implements OnInit,OnDestroy{
  serialNumber: any='';
  filteredProduct:any=null;
  productNotFound=false;
  productDetails:any;
  private destroy$=new Subject<void>();
  showserialNOInfo: boolean = false;
  constructor(private launchDialogService: LaunchDialogService,private rmaService:RmaService,private router: Router){
    
    
    
  }

  ngOnInit(): void {
    this.launchDialogService.data$.pipe(takeUntil(this.destroy$)).subscribe((data:any)=>{
      console.log('modal data:',data);
      this.serialNumber= data?.serialNumber || '';
      this.productDetails=data?.productDetails || null;
      console.log('modal serial numberdata:',this.serialNumber);
      console.log('modal api data:',this.productDetails);
      this.filteredProduct=this.productDetails;
      this.productNotFound=false;
      this.searchForSerialNumberProduct();
    });
  }

  searchForSerialNumberProduct(): void{
const enteredSerialNumber =
this.serialNumber?.trim();
if(!enteredSerialNumber){
  this.filteredProduct=null;
  this.productNotFound=false;
  return;
}
 console.log('modal search serial:',enteredSerialNumber);
 this.rmaService.guestSearchSerial(enteredSerialNumber).subscribe({
next: (res: any) => {
          console.log('Modal API Response:',res);
          this.productDetails = res;
          this.filteredProduct = res;
          this.productNotFound = false;
          console.log('Updated Product:',this.filteredProduct);
        },
        error: (error) => {
          console.error('Modal Guest Serial API Error:',error);
          this.productDetails = null;
          this.filteredProduct = null;
          this.productNotFound = true;
        },
      });
  }
closeForm(){
  console.log('close');
  this.launchDialogService.closeDialog(null);
}

help(){
  this.router.navigateByUrl('waygate/contactus');
}
clearSerialNumber():void{
  this.serialNumber='';
  this.filteredProduct = null;
  this.productDetails=null;
  this.productNotFound=false;
}
ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}
confirmProduct(): void{
  console.log('comfirm clicked');
const enteredSerialNumber=this.serialNumber?.trim();
if(!enteredSerialNumber || ! this.filteredProduct){
  console.log('confirm blocked:',{
    enteredSerialNumber,filteredProduct:this.filteredProduct
  });
  return;
}
console.log("confirmed product:",this.filteredProduct);
this.launchDialogService.closeDialog(this.filteredProduct);
}
}
